"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BiColorCheck = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * PRO-TIP
 * Wrap SVGs in a containing div is for compatibility with IE11,
 * which considers SVG elements read-only and so will not be able to apply animations to them.
 * It can however apply them to their containers
 */

/**
 * This is a deconstruction of FontAwesome's circle-check-o icon to allow
 * for coloring the background circle and foreground check seperately.
 */
var BiColorCheck = function BiColorCheck(_ref) {
  var rest = Object.assign({}, _ref);

  /* eslint-disable max-len */

  /* This comes from the pathing of react-icon's FontAwesome check-circle-o */
  var checkPath = 'm29.1 18.1l-9.4 9.5q-0.4 0.4-1 0.4t-1-0.4l-6.6-6.6q-0.4-0.4-0.4-1t0.4-1l2.3-2.3q0.4-0.4 1-0.4t1 0.4l3.3 3.3 6.2-6.1q0.4-0.5 1-0.5t1 0.5l2.2 2.2q0.5 0.5 0.5 1t-0.5 1z';

  var svgProps = _objectSpread({
    fill: 'currentColor',
    preserveAspectRatio: 'xMidYMid meet',
    height: '1em',
    width: '1em',
    viewBox: '0 0 40 40',
    style: {
      verticalAlign: 'middle'
    }
  }, rest);

  return _react.default.createElement("svg", svgProps, _react.default.createElement("circle", {
    className: "icon-check__circle",
    cy: "20",
    cx: "20",
    r: "19"
  }), _react.default.createElement("path", {
    className: "icon-check__check",
    d: checkPath
  }));
};

exports.BiColorCheck = BiColorCheck;